import type { ClientPropertyFlatDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { FLAT_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/FlatForm/flatFormDefaults";
import type { FlatFormInput } from "web_myplann/Portfolio/Forms/FlatForm/flatFormSchema";

export const mapPropertyToFlatForm = (
	property: ClientPropertyFlatDetailResponseDTO,
): FlatFormInput => ({
	location: property.location ?? DEFAULTS.location,
	locationMunicipality:
		property.locationMunicipality ?? DEFAULTS.locationMunicipality,
	locationZipCode: property.locationZipCode ?? DEFAULTS.locationZipCode,
	usableArea: property.usableArea ?? DEFAULTS.usableArea,
	floorArea: property.floorArea ?? DEFAULTS.floorArea,
	disposition: property.disposition ?? DEFAULTS.disposition,
	buildingMaterial: property.buildingMaterial ?? DEFAULTS.buildingMaterial,
	interiorValue: property.interiorValue ?? DEFAULTS.interiorValue,
	purchaseDate: parseIsoDate(property.purchaseDate),
	description: property.description ?? DEFAULTS.description,
	terrace: property.terrace ?? DEFAULTS.terrace,
	loggia: property.loggia ?? DEFAULTS.loggia,
	balcony: property.balcony ?? DEFAULTS.balcony,
	garage: property.garage ?? DEFAULTS.garage,
	cellar: property.cellar ?? DEFAULTS.cellar,
	elevator: property.elevator ?? DEFAULTS.elevator,
	barrierFree: property.barrierFree ?? DEFAULTS.barrierFree,
	swimmingPool: property.swimmingPool ?? DEFAULTS.swimmingPool,
	forInvestments: property.forInvestments ?? DEFAULTS.forInvestments,
});
